import { getFirestore, collection, orderBy, getDocs, query } from "firebase/firestore";
import uniformRequestConverter from "../converters/uniformRequestConverter";

export const queryUniformRequestsByIdNumber = async (idNumber: string) => {
  const db = getFirestore();
  const q = query(collection(db, `Employees/${idNumber}/UniformRequests`), orderBy('dateRequested', 'desc')).withConverter(uniformRequestConverter);
  return (await getDocs(q)).docs.map((d) => d.data());
};